import { forwardRef } from "react";
import { IMaskInput } from "react-imask";

interface MaskedInputProps {
  mask: string;
  error?: string;
  placeholder?: string;
  id?: string;
  name?: string;
  value?: string;
  className?: string;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  maxLength?: number;
}

export const MaskedInput = forwardRef<HTMLInputElement, MaskedInputProps>(
  ({ mask, error, className = "", onChange, onBlur, ...props }, ref) => {
    return (
      <div className="space-y-2">
        <IMaskInput
          mask={mask}
          inputRef={ref}
          onAccept={(value: string) => {
            if (onChange) {
              const event = {
                target: {
                  name: props.name,
                  value: value,
                },
              } as React.ChangeEvent<HTMLInputElement>;
              onChange(event);
            }
          }}
          onBlur={onBlur}
          className={`flex h-12 w-full rounded-xl border ${
            error ? "border-red-500" : "border-gray-200"
          } bg-white px-4 py-3 text-base shadow-sm transition-colors placeholder:text-gray-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#24a878] focus-visible:border-transparent disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
          {...props}
        />
        {error && <p className="text-sm text-red-500">{error}</p>}
      </div>
    );
  }
);

MaskedInput.displayName = "MaskedInput";
